import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { colors } from 'utils/styles/theme';

interface SocialWrapperProps {
  hoverTextColor?: string;
}

export const ShareListWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SocialWrapper = styled.div<SocialWrapperProps>`
  display: flex;
  align-items: center;

  ${({ hoverTextColor }) =>
    hoverTextColor?.length &&
    css`
      & a {
        &:hover {
          color: ${colors[hoverTextColor] ?? hoverTextColor};
        }
      }
    `}
`;

export const Label = styled.div`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  margin-right: 12px;
`;

export const SocialButton = styled.a`
  ${({ theme: { locale } }) => setTypography('filter', locale)}
  padding: 10px 16px;
  margin-right: 8px;
  border-radius: 33px;
  background-color: ${colors.concrete};
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: ${colors.alto};
  }
`;
